import { action, makeObservable, observable } from 'mobx'
import { persist } from 'mobx-persist'

class StationStore {
  @persist('object')
  @observable
  activeStationId?: string | null = null

  constructor() {
    makeObservable(this)
  }

  getActiveStationName() {
    return 'Foo'
  }

  getActiveStationId() {
    return this.activeStationId
  }

  @action
  setActiveStationId(activeStationId?: string) {
    this.activeStationId = activeStationId
  }
}

export default new StationStore()
